import { Box, Button, CircularProgress, Typography } from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import CustomSwipableDrawer from "../customSwipableDrawer/CustomSwipableDrawer";
import AudioPlayer from "../audioPlayer/AudioPlayer";
import listenToRecordingImg from "../../assets/listen_to_recording_img.svg";
import QualityChecksInstruction from "../../components/QualityChecksInstruction/QualityChecksInstruction";
import "./styles.css";
import { produceEventLog } from "../../utils/helper";
import { getUserProperties } from "../../utils/helper";
import useParamValues from "../../utils/useParamValues";

const SaveAudioConfirmationDrawer = ({
  openDrawer,
  audioBlob,
  audioBlobRef,
  setAudioBlobRef,
  onClickPrimaryButton,
  onClickSecondaryButton,
  uploadDataLoading,
  currentStep,
}) => {
  const { t, activeLanguage } = useTranslationSetup();
  const userProperties = getUserProperties(useParamValues());

  const handleOnClickRetakeButton = () => {
    onClickSecondaryButton();
    produceEventLog("assessment_retake2_button", {
      ...userProperties,
      assessment_flow: currentStep,
    });
  };

  return (
    <CustomSwipableDrawer
      open={openDrawer}
      preventDefault={true}
      anchor="bottom"
      className="save-audio-confirmation"
    >
      <Box className="listen-to-recording-container">
        <img
          className="listen-to-recording-img"
          src={listenToRecordingImg}
          alt="avoidNoiceImg"
        />
        <Typography className="listen-to-recording" lang={activeLanguage}>
          {t("listen_to_recording")}
        </Typography>
      </Box>

      {audioBlob && (
        <Box className="save-audio-confirmation-audio-player-container">
          <AudioPlayer
            audioBlob={audioBlob}
            audioBlobRef={audioBlobRef}
            setAudioBlobRef={setAudioBlobRef}
            currentStep={currentStep}
            onPlayEventName="assessment_play1_button"
            onPauseEventName="assessment_pause1_button"
          />
        </Box>
      )}

      <Box
        sx={{
          margin: "32px 14px 40px",
        }}
      >
        <QualityChecksInstruction
          headingText={t("ensure_while_listen_recording")}
          borderColor="#F3F3F3"
          headingColor="#313B1A"
          contentColor="#6E6E6E"
          border="0.5px"
          boxShadow="0px 4px 34px 0px rgba(18, 18, 18, 0.06)"
          t={t}
        />
      </Box>

      <Box className="save-audio-confirmation-button-container">
        <Button
          className={`custom-ff-medium save-audio-confirmation-save-button btn-primary ${uploadDataLoading ? "disabled" : ""}`}
          variant="contained"
          lang={activeLanguage}
          disableElevation
          onClick={onClickPrimaryButton}
          disabled={uploadDataLoading}
        >
          {uploadDataLoading ? (
            <CircularProgress className="button-loader" />
          ) : (
            t("submit")
          )}
        </Button>
      </Box>
      <Box className="save-audio-confirmation-button-container">
        <Button
          className={`custom-ff-regular save-audio-confirmation-retake-button theme-color ${uploadDataLoading ? "disabled" : ""}`}
          variant="outlined"
          lang={activeLanguage}
          disableElevation
          onClick={handleOnClickRetakeButton}
          disabled={uploadDataLoading}
        >
          {t("retake")}
        </Button>
      </Box>
    </CustomSwipableDrawer>
  );
};

export default SaveAudioConfirmationDrawer;
